import { render } from "./Cardrotation.vue?vue&type=template&id=50ec5abd&scoped=true"
import script from "./Cardrotation.vue?vue&type=script&lang=js"
export * from "./Cardrotation.vue?vue&type=script&lang=js"

import "./Cardrotation.vue?vue&type=style&index=0&id=50ec5abd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ec5abd"]])

export default __exports__